module.exports = __webpack_public_path__ + "img/four_red.fd04c6aa.png";